export default {
  buttons: {
    next: "بعدی",
    prev: "قبلی",
    skip: "رد کردن",
    done: "پایان",
    gotIt: "فهمیدم",
  },
  messages: {
    dontShowAgainLabel: "دیگر این را نشان نده",
    stepNumbersOfLabel: "از",
  },
};
